import styled from 'styled-components/macro'
import { Input } from '@kupibilet/ui/components/Input'

export const InputStyled = styled(Input)`
  min-width: 0;
`
